module.exports = __webpack_public_path__ + "static/media/view canteen category.09dc2a8d.svg";